module.exports = __webpack_public_path__ + "img/BlinkArt_Sword6_Blue.7f884d9f.png";